<template>
	<div
		v-if="visible"
		class="federated-search-landing-modal"
		role="dialog"
		aria-modal="true"
		aria-labelledby="federated-search-landing-modal-label"
		@keydown="handleKeydown"
	>
		<div class="federated-search-landing-modal__container">
			<div class="federated-search-landing-modal__inner" ref="modalContainer">
				<button
					aria-label="Close Modal View"
					class="federated-search-landing-modal__close-button"
					@click="closeModal"
					ref="closeButton"
					type="button"
				>
					<span></span>
				</button>
				<div
					class="federated-search-landing-modal__content"
					v-html="content"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ahc-federated-search-landing-modal",
	props: {
		content: {
			type: String,
			required: true,
			default: "",
		},
	},
	data() {
		return {
			visible: true,
		};
	},
	methods: {
		closeModal() {
			this.visible = false;
			this.setCookie("federatedSearchModalDisplayed", "true", 365);
			document.body.classList.remove("modal-open");
		},
		checkCookie(name) {
			const match = document.cookie.match(
				new RegExp("(^| )" + name + "=([^;]+)")
			);
			return match ? match[2] : null;
		},
		setCookie(name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
		},
		handleKeydown(event) {
			if (event.code === "Escape") {
				this.closeModal();
			} else if (event.code === "Tab") {
				this.handleFocusTrap(event);
			}
		},
		handleFocusTrap(event) {
			const focusableElements = this.$refs.modalContainer.querySelectorAll(
				'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
			);
			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];

			if (event.shiftKey && document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
			} else if (!event.shiftKey && document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			}
		},
	},
	mounted() {
		if (this.checkCookie("federatedSearchModalDisplayed") || !this.content) {
			this.visible = false;
			document.body.classList.remove("modal-open");
		} else {
			this.visible = true;
			document.body.classList.add("modal-open");
			this.$nextTick(() => {
				this.$refs.closeButton.focus();
			});
			document.addEventListener("keydown", this.handleKeydown);
		}
	},
	beforeUnmount() {
		document.removeEventListener("keydown", this.handleKeydown);
		document.body.classList.remove("modal-open");
	},
};
</script>

<style lang="scss">
@import "federated-search-landing-modal";
</style>
